import ActionsMenu, { IMenuOption } from './actionsMenu';

export default ActionsMenu;
export type { IMenuOption };
